export default "__VITE_ASSET__MDKmIYM6__"